import React, {Component} from 'react';
import MediaConnectionPage from "../components/MediaConnectionPage";
import BaseComponent from "../../../base/BaseComponent";
import {HEADER_HEIGHT} from "../../../constants";
import {Modal, Input, message, Button, Tree, InputNumber, Icon, Popconfirm, Form, DatePicker} from "antd";
import moment from "moment";
import noView from "../image/noView.png"
import noView2 from "../image/noView2.png"
import MyIconSvg from '../iconSvg/svg'
import UploadAtlas from "./uploadAtlas/UploadAtlas";
import ImageRelease from "./imageRelease/ImageRelease";
import Photos from "./photos/photos";
import {uuid} from "../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import RmtPopconfirm from "../../components/rmtPopconfirm/rmtPopconfirm";
import StorySortModal from "../../components/storySortModal/StorySortModal";
import Titlepicfile from "../../components/titlepicfile/Titlepicfile";
import {getColorByState} from "../../components/colorByState/colorByState";

const {Search} = Input;
const {TreeNode} = Tree;
const FormItem = Form.Item;
const {RangePicker} = DatePicker;
const getNodesUrl = "/cm-sites-pms/contribute/nodes";
const collectUrl = "/cm-sites-pms/contribute/collect";
const cancelCollectionUrl = "/cm-sites-pms/contribute/cancel";
const contributeUrl = "/cm-sites-pms/website/news/contribute";
const getWebSiteVersion = "/cm-sites-pms/media/getWebSiteVersion";
const setImportance = "/cm-sites-pms/website/news/setImportance";
const doStoryState = {
    undo: '/cm-sites-pms/website/news/undo', // 撤稿
    doFirst: '/cm-sites-pms/website/news/doFirst', // 头条
    undoFirst: '/cm-sites-pms/website/news/undoFirst', // 取消头条
    doRecommend: '/cm-sites-pms/website/news/doRecommend', // 推荐
    undoRecommend: '/cm-sites-pms/website/news/undoRecommend', // 取消推荐
    doTop: '/cm-sites-pms/website/news/doTop', // 置顶
    undoTop: '/cm-sites-pms/website/news/undoTop', // 取消置顶
    needTime: ['doTop'], // 需要时间的接口
};
const { confirm } = Modal;

class NetworkMediaJump extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabKey: '全部',
            visible: false,
            navigationBarDate: [
                {
                    key: '全部',
                    url: '/cm-sites-pms/website/news/all',
                },
                {
                    key: '我的稿件',
                    url: '/cm-sites-pms/website/news/myNews',
                },
                {
                    key: '草稿',
                    url: '/cm-sites-pms/website/news/draft',
                },
                {
                    key: '审核中',
                    url: '/cm-sites-pms/website/news/auditing',
                },
                {
                    key: '已发布',
                    url: '/cm-sites-pms/website/news/publishList',
                },
                {
                    key: '已弃用',
                    url: '/cm-sites-pms/website/news/abandon',
                },
                {
                    key: '已撤稿',
                    url: '/cm-sites-pms/website/news/withdraw',
                },
            ],//tab栏key和url
            params: {
                keywords: '',
                page: 1,
                size: 10,
            },
            dataSource: [],
            total: 0,// 数据总条数
            mediaId: "",//媒体id
            treeId: "",//栏目id
            contentId: "",//资料员id
            treeContentId: "",//资料员id
            editorWindow: null,// 编辑器window对象
            addMosaicReleaseVisible: false,
            treeNodeVisible: false,
            UploadAtlasVisible: false,//上传图集弹框是否显示
            imageReleaseVisible: false,//组图发布弹框是否显示
            dialogKey: uuid(),
            treeData: [],
            // 展开的节点树
            expandedKeys: [],
            // 搜索到的key
            searchExpandedKeys: [],
            // 选中的节点
            checkedKeys: [],
            autoExpandParent: true,
            // node搜索框内容
            searchText: "",
            // 当前文章id
            webNewsId: 0,
            treeNodeWithdrawVisible: false,
            treeWithdrawData: [],
            selectTimeVisible: false,
            toptime: null,// 置顶开始
            gotoptime: null,// 置顶结束
            webSiteVersion: '',// 站群版本
            disable:1,
            renderSelectTimeKey: uuid(),
            renderModalKey:uuid()
        }

    }

    componentWillMount() {
        this.state.tabKey = "全部";
        let mediaId = this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        this.state.mediaId = mediaId;
        let treeId = this.props.match.params.treeId ? this.props.match.params.treeId : '';
        this.state.treeId = treeId;
        let contentId = this.props.match.params.contentId ? this.props.match.params.contentId : '';
        this.state.contentId = contentId;
        this.state.treeContentId = contentId;
        let that = this;
        // 监听 EditorInformationOfWebEditor 页面发送的消息
        this.createPostMessage((e) => {
            let message = e['data']&&typeof e['data']=='string'? JSON.parse(e['data'])['message'] : null;
            if (message == "请求媒体参数") {
            } else if (message == "请求刷新父页面") {
                that.getSiteListContent()
            }
        }, "NetworkMediaJump")
    }

    componentDidMount() {
        this.getSiteListContent();
        this.getNodes();
        this.getWebSiteVersion();
        this.getMediaById()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.tabKey = "全部";
        let mediaId = nextProps.match.params.mediaId ? nextProps.match.params.mediaId : '';
        this.state.mediaId = mediaId;
        let treeId = nextProps.match.params.treeId ? nextProps.match.params.treeId : '';
        this.state.treeId = treeId;
        let contentId = nextProps.match.params.contentId ? nextProps.match.params.contentId : '';
        this.state.contentId = contentId;
        this.state.treeContentId = contentId;
        this.setState({}, () => {
            this.getSiteListContent();
            this.getWebSiteVersion();
            this.getMediaById();
        });
    }

    componentWillUnmount() {
        let that = this;
        // 销毁postMessage监听
        this.destroyPostMessage("NetworkMediaJump");
        this.refreshTimeout = null;
        clearTimeout(that.getSiteListContent);
    }

    render() {
        let {tabKey, navigationBarDate, total, dataSource, params, mediaId, treeId, contentId, webSiteVersion, disable} = this.state;
        let props = {
            tabChange: this.tabChange, // tab切换
            onChange: this.onSearch, //搜索功能按钮等
            saveSignificance: disable==1?null:(webSiteVersion < '990' ? this.saveSignificance : null), // 保存重要性 882
            saveSort: disable==1?null:( webSiteVersion >= '990' ? this.saveSort : null), // 文章排序 990
            refresh: this.refresh, // 刷新页面
            visitWebsite: this.visitWebsite,//访问网站
            WebsiteManagementButton: this.WebsiteManagementButton,//网站管理
            addStory: disable==1?null:this.addStory, // 新增稿件
            columns: this.renderColumns(),  //表格表头
            dataSource: dataSource, //表格数据
            total: total,
            navigationBarDate: navigationBarDate,
            params: params,
            tabKey: tabKey,
            // tableHeight: window.innerHeight - HEADER_HEIGHT - 56 - 57 - 24 - 81 - 30,
            tableHeight: "calc(100vh - 318px)",
            mediaId, treeId, contentId,
            // 组图功能按钮
            photos: disable==1?null:<Photos
                key={this.state.dialogKey}
                ref={ref=>this.photos=ref}
                btnName={'新增组图'}
                dynamicParams={{
                    mediaId, treeId, contentId,
                }}
                onOkCall={() => {
                    this.getSiteListContent();
                    this.setState({dialogKey: uuid()})
                }}/>,
            disable,
        };
        return (
            <div style={{
                margin: '15px',
                maxHeight: 'calc(100vh - 100px)',
                borderRadius: '5px',
                overflow: 'hidden',
                background: 'rgb(255, 255, 255)'
            }}>
                <MediaConnectionPage {...props}/>
                {this.renderModal()}
                {this.renderWithdrawModal()}
                {this.renderSelectTime()}
                <StorySortModal ref={ref=>this.storySortModal=ref} mediaCode={this.state.mediaId} treeContentId={this.state.contentId}/>
            </div>
        );
    };

    //投稿至弹框
    renderModal = () => {
        const {treeData} = this.state;
        let floor = 0;
        return (
            <Modal
                centered={true}
                title="投稿至"
                visible={this.state.treeNodeVisible}
                onOk={this.contributeOk}
                onCancel={() => {
                    this.setState({treeNodeVisible: false,renderModalKey:uuid()})
                }}
                width={320}
                key={this.state.renderModalKey}
            >
                <Search
                    placeholder="请输入关键词"
                    onSearch={this.onNodeSearch}
                    style={{margin: "10px 0"}}
                />
                <Scrollbars style={{height: 300,}}>
                    {(treeData && treeData.length) ? <Tree
                        showIcon
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        expandedKeys={this.state.expandedKeys}
                        autoExpandParent={this.state.autoExpandParent}
                        checkedKeys={this.state.checkedKeys}
                        // selectedKeys={this.state.selectedKeys}
                        onExpand={this.onExpand}
                        selectable={false}
                        // onSelect={this.onSelect}
                        onCheck={this.onCheck}
                    >
                        {this.renderTreeNodes(treeData, floor)}
                    </Tree> : null}
                </Scrollbars>
            </Modal>
        )
    };

    // 日期选择器禁用规范(返回需要禁用的区域)
    disabledPriceRangeDate = (current, key) => {
        let startTime = this.state[key];
        let newDate = Date.now();
        let thisDay = moment(current).endOf("day").format('x') * 1;
        let thisPublishTime = moment(startTime).format('x') * 1 + 1000;
        if (startTime && startTime >= newDate) {
            return thisDay <= thisPublishTime;
        }else{
            return thisDay < newDate;
        }
        return null
    };

    range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };
    // 时间选择器禁用规范(返回需要禁用的区域)
    disabledDateTime = (current, key) => {
        let startTime = this.state[key];
        let thisDateOf0 = moment(current).startOf("day").format('x');
        console.log("当前时间是：", moment(current).format("YYYY-MM-DD HH-mm-ss"));
        if (startTime && startTime > thisDateOf0) {
            const diffDuration = moment(current);
            const hours = diffDuration.hours();
            const minutes = diffDuration.minutes();
            const seconds = diffDuration.seconds();
            const publishDiffDuration = moment(startTime);
            let publishHours = publishDiffDuration.hours();
            let publishMinutes = 0;
            let publishSeconds = 0;
            if(hours<=publishHours) {
                publishMinutes = publishDiffDuration.minutes();
                if(minutes<=publishMinutes) {
                    publishSeconds = publishDiffDuration.seconds()*1+1;
                }
            }
            return {
                disabledHours: () => this.range(0, 24).splice(0, publishHours),
                disabledMinutes: () => this.range(0, 60).splice(0, publishMinutes),
                disabledSeconds: () => this.range(0, 60).splice(0, publishSeconds),
            };
        }
        return {};
    };

    // 选择时间弹窗
    renderSelectTime = () => {
        if(this.state['gotoptime'] && this.state['gotoptime']<=this.state['toptime']) {
            // 重置结束时间
            this.state['gotoptime'] = null
        }
        return (
            <Modal
                centered={true}
                title="设置置顶时间"
                visible={this.state.selectTimeVisible}
                onOk={() => {
                    let {toptime,gotoptime} = this.state;
                    this.setState({selectTimeVisible: false,renderSelectTimeKey:uuid(),gotoptime: null,toptime: null},()=>{
                        this.onStoryStateOk({
                            toptime,
                            gotoptime,
                        });
                    });
                }}
                key={this.state.renderSelectTimeKey}
                onCancel={() => {
                    this.setState({selectTimeVisible: false,renderSelectTimeKey:uuid(),gotoptime: null,toptime: null})
                }}
                width={460}
            >
                <DatePicker showTime placeholder="不设置则立即置顶"
                            value={this.state.toptime?moment(this.state.toptime):null}
                            onChange={(value, dateString) => {
                                this.onRangePickerChange({value, dateString, startKey: 'toptime',});
                                this.onRangePickerChange({value:null, dateString, startKey: 'gotoptime',})
                            }}
                />
                <span> ~ </span>
                <DatePicker showTime placeholder="不设置则一直置顶"
                            disabledTime={(current)=>this.disabledDateTime(current, "toptime")}
                            disabledDate={(current)=>this.disabledPriceRangeDate(current,"toptime")}
                            value={this.state.gotoptime?moment(this.state.gotoptime):null}
                            onChange={(value, dateString) => {
                                let startTime = this.state.toptime;
                                let newTime = null;
                                if(value && value.valueOf()){
                                    newTime = value.valueOf()
                                }
                                if(startTime && newTime && startTime > newTime){
                                    let endDay = moment(newTime).endOf("day").valueOf();
                                    if(startTime < endDay) {
                                        newTime = endDay
                                    } else {
                                        message.error("下线时间不能早于发布时间");
                                        return false
                                    }
                                }
                                this.onRangePickerChange({value:newTime, dateString, endKey: 'gotoptime'})
                            }}/>
                <div style={{marginTop: 10,color:'rgb(156, 156, 156)'}}>
                    <span style={{color: 'rgb(255, 153, 6)'}}>注意：</span>如设置开始或结束时间，需要晚于当前时间至少10分钟
                </div>
            </Modal>
        )
    };

    // 渲染表头
    renderColumns = () => {
        const {webSiteVersion} = this.state;

        let showWeight = webSiteVersion>='990';
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    ellipsis: true,
                    // width: "35%",
                    width: "550px",
                    render: (text, record) => {
                        // let title = text;
                        // if (!title && record.variableFields && record.variableFields['title']) {
                        //     title = record.variableFields['title'];
                        // }
                        let createTime = (record.updateTime) ? moment(record.updateTime).format('YYYY-MM-DD HH:mm') : null;
                        let createName = record.variableFields.author || record.creatorName;
                        let titlePic = record.titlePic;
                        let wbtop = record.wbtop;
                        let wbtopdate = record.wbtopdate;
                        let wbgotopdate = record.wbgotopdate;
                        if (record.contentId * 1 != this.state.contentId * 1) {
                            // 寻找子栏目
                            let sonRecord = record.deliveryNews.find(item => item.contentId == this.state.contentId) || {};
                            titlePic = sonRecord.titlePic;
                            wbtop = sonRecord.wbtop;
                            wbtopdate = sonRecord.wbtopdate;
                            wbgotopdate = sonRecord.wbgotopdate;
                        }
                        let willStick = null;
                        if(
                            wbtop === 1 &&
                            wbtopdate &&
                            wbtopdate > Date.now()
                        ) {
                            willStick = (
                                <>
                                    <span style={{margin: "0px 24px"}}>|</span>
                                    <div style={{color: "#F5A123"}}>
                                        待置顶
                                    </div>
                                </>
                            )
                        }else if(
                            wbtop === 1 &&
                            wbgotopdate &&
                            wbgotopdate > Date.now()
                        ) {
                            willStick = (
                                <>
                                    <span style={{margin: "0px 24px"}}>|</span>
                                    <div style={{color: "#F5A123"}}>
                                        待取消
                                    </div>
                                </>
                            )
                        }
                        return (
                            <div className={'titleContent'}
                                 style={{width:"100%"}}>
                                {/*点击跳转*/}
                                <div
                                    onClick={() => {
                                        if(this.state.disable == 1 ){
                                            return false
                                        } else {
                                            if(record.atlasList && Array.isArray(record.atlasList) && record.atlasList.length > 0) {
                                                this.editPhotos(record);
                                            } else {
                                                this.editStory(record.id,record)
                                            }
                                        }
                                    }}
                                    style={{width:"100%"}}
                                >
                                    <div style={{display: 'flex',}}>
                                        <div style={{marginRight:8,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }} title={text} >{text}</div>
                                        {titlePic ?
                                            <img src={titlePic} style={{width:24,height:24,borderRadius: '2px',objectFit: "cover"}}/>
                                            : null}
                                    </div>
                                    <div style={{display: 'flex', fontSize: 14, paddingTop: 5, color: '#ABABAB',}}>
                                        <div style={{maxWidth:"160px", flex: " 1 1", minWidth: "67px", textOverflow:"ellipsis",overflow:"hidden",writeSpace:"nowrap"}}>作者:<span style={{marginLeft: 10}} title={createName}>{createName}</span></div>
                                        <div style={{marginLeft: 24, flex: "2 1 170px", maxWidth: "178px",minWidth: "60px"}}>
                                            修改时间:<span style={{marginLeft: 10}}>{createTime}</span>
                                        </div>
                                        {willStick}
                                    </div>
                                </div>
                            </div>
                        )
                    },
                },
                {
                    title: '置顶',
                    dataIndex: 'wbtop',
                    key: 'wbtop',
                    width: 100,
                    render: (text, record, index) => {
                        return this.renderRmtPopconfirm({
                            text, record, index,
                            urlKey1: 'doTop', // 执行url
                            urlKey2: 'undoTop', // 取消url
                            stateKey: 'wbtop', // 数据里面对应的状态key
                            titleVal: '置顶', // 数据里面对应的状态key
                            visible: 'topStatus', // 弹窗显示隐藏标志
                            doIcon: <MyIconSvg type={'topColor'} style={{size: 20,cursor:'pointer'}}/>,
                            undoIcon: <MyIconSvg type={'top'} style={{size: 20,cursor:'pointer'}}/>,
                        })
                    }
                },
                {
                    title: '头条',
                    dataIndex: 'wbfirst',
                    key: 'wbfirst',
                    width: 100,
                    render: (text, record, index) => {
                        return this.renderRmtPopconfirm({
                            text, record, index,
                            urlKey1: 'doFirst', // 执行url
                            urlKey2: 'undoFirst', // 取消url
                            stateKey: 'wbfirst', // 数据里面对应的状态key
                            titleVal: '头条', // 数据里面对应的状态key
                            visible: 'headlineStatus', // 弹窗显示隐藏标志
                            doIcon: <MyIconSvg type={'headlineColor'} style={{size: 20,cursor:'pointer'}}/>,
                            undoIcon: <MyIconSvg type={'headline'} style={{size: 20,cursor:'pointer'}}/>,
                        })
                    }
                },
                {
                    title: '推荐',
                    dataIndex: 'wbrecommend',
                    key: 'wbrecommend',
                    width: 100,
                    render: (text, record, index) => {
                        return this.renderRmtPopconfirm({
                            text, record, index,
                            urlKey1: 'doRecommend', // 执行url
                            urlKey2: 'undoRecommend', // 取消url
                            stateKey: 'wbrecommend', // 数据里面对应的状态key
                            titleVal: '推荐', // 数据里面对应的状态key
                            visible: 'recommendStatus', // 弹窗显示隐藏标志
                            doIcon: <MyIconSvg type={'recommendColor'} style={{size: 20,cursor:'pointer'}}/>,
                            undoIcon: <MyIconSvg type={'recommend'} style={{size: 20,cursor:'pointer'}}/>,
                        })
                    }
                },
                {
                    title: showWeight?'':'重要性',
                    dataIndex: 'wbweight',
                    key: 'wbweight',
                    width: showWeight?0:100,
                    render: (text, record, index) => {
                        let wbweight = text || 10;
                        let mainColumn = true; // 当前栏目为当前文章主栏目？
                        if(this.state.contentId != record.contentId) {
                            let sonRecord = record.deliveryNews.find(item => item.contentId == this.state.contentId) || {};
                            wbweight = sonRecord.wbweight || 10;
                            mainColumn = false;
                        }
                        return (
                            showWeight?null:(
                                <div>
                                    <InputNumber min={1} max={99999} value={wbweight*1} style={{width: 72, height: 32}}
                                                 onChange={(num)=>{
                                                    if(mainColumn) {
                                                        this.state.dataSource[index].wbweight = num
                                                    } else {
                                                        this.state.dataSource[index].deliveryNews.forEach(item=>{
                                                            if(item.contentId == this.state.contentId) {
                                                                item.wbweight = num
                                                            }
                                                        })
                                                    }
                                                    this.setState({})
                                                 }}/>
                                </div>
                            )
                        )
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width: 150,
                    render: (text) => {
                        let color = getColorByState(text);
                        return (
                            <div className={'dotState'}>
                                <div style={{background: color}}></div>
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    dataIndex: 'action',
                    width: 250,
                    render: (text, record, index) => {
                        let hasMore = record.deliveryNews && record.deliveryNews.length > 0;
                        let title = hasMore ? '该文章同时发布到多个栏目，请问需要同步撤除其他栏目吗？' : '确定要撤稿吗？';
                        let urlKey = 'undo';
                        return (
                            this.state.disable == 1 ? "" :
                            <div className={'a'}>
                                {
                                    <Button type={'link'} onClick={() => {
                                        if(record.linkurl) {
                                            window.open(record.linkurl, "newwindow");
                                            return false
                                        }
                                        if(record && record.id) {
                                            this.previewCall(record.id);
                                            return false
                                        }
                                    }} style={{marginLeft: -15}}>预览</Button>
                                }
                                {
                                    (record.statusName == "发布" || record.statusName == "已发布" || record.statusName == "定时发布") ?
                                        <RmtPopconfirm
                                            key={(record.id + index)}
                                            visible={record.undo}
                                            title={<div style={{marginLeft: 10}}>{title}</div>}
                                            icon={<Icon type={'question-circle'}
                                                        style={{color: '#faad14', fontSize: 22}}/>}
                                            footer={
                                                <div style={{display: 'flex', justifyContent: 'flex-end',}}>
                                                    <Button onClick={() => {
                                                        this.state.dataSource[index].undo = false;
                                                        this.setState({})
                                                    }}>取消</Button>
                                                    {
                                                        hasMore ?
                                                            <Button onClick={() => {
                                                                this.state.treeWithdrawData = [];
                                                                let deliveryNews = [...record.deliveryNews, {
                                                                    contentId: record.contentId,
                                                                    mediaId: record.mediaId,
                                                                    contentName: record.contentName,
                                                                    mediaName: record.mediaName,
                                                                }];
                                                                this.setTreeWithdrawData(deliveryNews);
                                                                this.state.dataSource[index].undo = false;
                                                                this.setState({
                                                                    renderWithdrawModalTitle: '选择需要撤稿的栏目',
                                                                    treeNodeWithdrawVisible: true,
                                                                })
                                                            }}>选择栏目</Button>
                                                            : null
                                                    }
                                                    {
                                                        hasMore ?
                                                            <Button onClick={() => {
                                                                let treeContentIds = this.state.treeContentId;
                                                                this.state.dataSource[index].undo = false;
                                                                this.setState({});
                                                                this.doStoryState(treeContentIds, 'undo')
                                                            }}>当前栏目</Button>
                                                            : null
                                                    }
                                                    <Button onClick={() => {
                                                        let treeContentIds = record.contentId;
                                                        if (record && record.deliveryNews && record.deliveryNews.length) {
                                                            record.deliveryNews.forEach(item => {
                                                                treeContentIds += (',' + item.contentId)
                                                            })
                                                        }
                                                        this.state.dataSource[index].undo = false;
                                                        this.setState({});
                                                        this.doStoryState(treeContentIds, 'undo')
                                                    }} type={'primary'}>{hasMore ? '全部撤稿' : '撤稿'}</Button>
                                                </div>
                                            }
                                        >
                                            <Button type={'link'} onClick={() => {
                                                this.state.webNewsId = record.id;
                                                this.state.record = record;
                                                this.state.dataSource[index].undo = true;
                                                this.state.urlKey = urlKey;
                                                this.setState({})
                                            }} style={{marginLeft: -15}}>撤稿</Button>
                                            {
                                                // 组图和非发布状态稿件不能拾取
                                                (
                                                    (record.atlasList && Array.isArray(record.atlasList) && record.atlasList.length > 0) ||
                                                    (record.statusName != "发布" && record.statusName != "已发布")
                                                ) ? "" :
                                                    (<Button type={'link'} onClick={() => {
                                                        this.setState({treeNodeVisible: true,renderModalKey:uuid(), webNewsId: record.id})
                                                    }} style={{marginLeft: -15}}>投稿至</Button>)
                                            }
                                        </RmtPopconfirm>
                                        : null
                                }
                                {
                                    (
                                        record.statusName.indexOf('草稿') > -1 ||
                                        record.statusName.indexOf('撤稿') > -1 ||
                                        record.statusName.indexOf('弃用') > -1
                                    ) ? <Button type={'link'} onClick={() => {
                                        let that = this
                                            confirm({
                                                title: '确定要删除吗?',
                                                content: '',
                                                onOk() {
                                                    that.delStory(record.id);
                                                },
                                                onCancel() {
                                                    console.log('Cancel');
                                                },
                                            });
                                        }} style={{marginLeft: -15}}>删除</Button>
                                        : null
                                }
                                {
                                    record.statusName == '发布失败' ? (
                                        <span className={"Failure"}>
                                            <Popconfirm getPopupContainer={triggerNode => triggerNode.parentNode} title={this.state.errorInfoValue}>
                                                <Button style={{marginLeft: -7}} size={'small'} type={'link'} onClick={() => {
                                                    this.getFailure(record.id)
                                                }}>失败原因</Button>
                                            </Popconfirm>
                                            <style>{`.Failure .ant-popover-buttons{display:none !important;} `}</style>
                                        </span>) : null
                                }
                            </div>
                        )
                    },
                },
            ]
        )
    };
    getFailure(id) {
        this.request({
            url: "/cm-sites-pms/index/publishLog",
            body: {id: id},
            callBack: (data) => {
                let errorInfoValue =""
                if(data){
                    errorInfoValue = data.errorInfo
                }
                this.setState({errorInfoValue})

            }
        })
    }

    renderRmtPopconfirm = ({text, record, index, urlKey1, urlKey2, stateKey, titleVal, visible, doIcon, undoIcon}) => {
        // 0 未置顶 1 置顶
        let isTop = text;
        let hasMore = record.deliveryNews && record.deliveryNews.length > 0; // 是否多栏目
        let allColumn = [...record.deliveryNews, {
            contentId: record.contentId,
            mediaId: record.mediaId,
            contentName: record.contentName,
            mediaName: record.mediaName,
            [stateKey]: record[stateKey],
        }]; // 所有栏目集合
        let urlKey = urlKey1;
        // 如果不是主栏目则需要另外判断
        if (hasMore && (record.contentId * 1 != this.state.contentId * 1)) {
            // 寻找子栏目置顶状态
            let sonRecord = record.deliveryNews.find(item => item.contentId == this.state.contentId) || {};
            isTop = sonRecord[stateKey]
        }
        let similar = allColumn.filter(column => column[stateKey] == isTop); // 与当前栏目相同状态的栏目集合
        let havMore = similar.length > 1 ? true : false; // 是否存在与当前栏目状态相同的其他栏目
        let title = havMore ? `该文章同时发布到多个栏目，请问其他栏目需要同步设置${titleVal}吗？` : `确定要设置${titleVal}吗？`;
        let allBtnName = havMore ? `全部${titleVal}` : `${titleVal}`;
        let renderWithdrawModalTitle = `选择需要设置${titleVal}的栏目`;
        if (isTop) {
            renderWithdrawModalTitle = `选择需要取消设置${titleVal}的栏目`;
            title = havMore ? `该文章同步设置${titleVal}到多个栏目，请问需要取消其他栏目${titleVal}吗？` : `确定要取消设置${titleVal}吗`;
            allBtnName = havMore ? `全部取消` : `取消${titleVal}`;
            urlKey = urlKey2;
        }
        return (
            <RmtPopconfirm
                key={(record.id + index)}
                visible={record[visible]}
                title={<div style={{marginLeft: 10}}>{title}</div>}
                icon={<Icon type={'question-circle'}
                            style={{color: '#faad14', fontSize: 22}}/>}
                footer={
                    <div style={{display: 'flex', justifyContent: 'flex-end',}}>
                        <Button onClick={() => {
                            this.state.dataSource[index][visible] = false;
                            this.setState({})
                        }}>取消</Button>
                        {
                            havMore ?
                                <Button onClick={() => {
                                    this.state.treeWithdrawData = [];
                                    this.setTreeWithdrawData(similar, {
                                        key: stateKey,
                                        val: isTop,
                                    });
                                    this.state.dataSource[index][visible] = false;
                                    this.setState({
                                        renderWithdrawModalTitle: renderWithdrawModalTitle,
                                        treeNodeWithdrawVisible: true,
                                    })
                                }}>选择栏目</Button>
                                : null
                        }
                        {
                            havMore ?
                                <Button onClick={() => {
                                    let treeContentIds = this.state.treeContentId;
                                    this.state.dataSource[index][visible] = false;
                                    this.setState({});
                                    this.state.checkedWithdrawKeys = [treeContentIds];
                                    this.onStoryStateOk();
                                    // this.doStoryState(treeContentIds, urlKey)
                                }}>当前栏目</Button>
                                : null
                        }
                        <Button onClick={() => {
                            this.state.dataSource[index][visible] = false;
                            this.state.checkedWithdrawKeys = similar.map(item => item.contentId);
                            this.onStoryStateOk()
                        }} type={'primary'}>{allBtnName}</Button>
                    </div>
                }
            >
                <div onClick={() => {
                    if(this.state.disable == 1){
                        return false
                    }else {
                        this.state.webNewsId = record.id;
                        this.state.record = record;
                        this.state.urlKey = urlKey;
                        if(havMore) {
                            this.state.dataSource[index][visible] = true;
                            this.setState({});
                        } else {
                            this.state.checkedWithdrawKeys = similar.map(item => item.contentId);
                            this.onStoryStateOk()
                        }
                    }
                }}>
                    {isTop ? doIcon : undoIcon}
                </div>
            </RmtPopconfirm>
        )
    };

    // 稿件状态修改，栏目选择弹窗
    renderWithdrawModal = () => {
        const {treeWithdrawData} = this.state;
        return (
            <Modal
                centered={true}
                title={this.state.renderWithdrawModalTitle}
                visible={this.state.treeNodeWithdrawVisible}
                onOk={() => {
                    this.onStoryStateOk()
                }}
                onCancel={() => {
                    this.setState({treeNodeWithdrawVisible: false, checkedWithdrawKeys: []})
                }}
                width={400}
            >
                <Scrollbars style={{height: 350,}}>
                    {(treeWithdrawData && treeWithdrawData.length) ? <Tree
                        showIcon
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        selectable={false}
                        // expandedKeys={this.state.expandedKeys}
                        autoExpandParent={this.state.autoExpandParent}
                        checkedKeys={this.state.checkedWithdrawKeys}
                        // selectedKeys={this.state.selectedKeys}
                        // onExpand={this.onExpand}
                        // onSelect={this.onSelect}
                        onCheck={this.onWithdrawCheck}
                    >
                        {this.renderWithdrawTreeNodes(treeWithdrawData)}
                    </Tree> : null}
                </Scrollbars>
            </Modal>
        )
    };

    renderTreeNodes = (data, floor) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode title={this.renderTitle("folder-open", item, floor)} key={item.id} dataRef={item}>
                        {this.renderTreeNodes(item.child, floor + 1)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderTitle("file-text", item, floor)}/>;
        });

    renderWithdrawTreeNodes = (data) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode disabled={true} title={this.renderWithdrawTitle("folder-open", item)} key={item.id}
                              dataRef={item}>
                        {this.renderWithdrawTreeNodes(item.child)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderWithdrawTitle("file-text", item)}/>;
        });

    renderTitle = (type, item, floor) => {
        const index = this.state.searchText.length > 0 ? item.name.indexOf(this.state.searchText) : -1;
        let width1 = 190 - floor * 19;
        let width2 = 160 - floor * 19;
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: width1,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon type={type}/>
                    <span style={{
                        width: width2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        color: index > -1 ? '#f50' : 'unset'
                    }}
                    >{item.name}</span>
                </div>
                <div onClick={() => {
                    this.setCollect(item)
                }}>{item.collect ? <Icon type="star" theme="filled" style={{color: "#f0a738"}}/> :
                    <Icon type="star"/>}</div>
            </div>
        )
    };

    renderWithdrawTitle = (type, item) => {
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: 190,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon type={type}/>
                    <span style={{
                        width: 160,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}
                    >{item.name}</span>
                </div>
            </div>
        )
    };

    // 获取投稿部门/媒体树
    contribute = (body) => {
        this.request({
            url: contributeUrl,
            method: 'post',
            body,
            callBack: (res) => {
                // if (res) {
                message.success('投递成功');
                // } else {
                //     message.error('投递失败')
                // }
                this.getSiteListContent()
            },
            errorCallBack: (e) => {
            }
        })
    };
    refreshTimeout;
    refresh = () => {
        let that = this;
        window.loading.show();
        this.refreshTimeout = setTimeout(that.getSiteListContent, 1000)
    };

    //获取tab栏对应的表格数据
    getSiteListContent = () => {
        let {tabKey, navigationBarDate, mediaId, treeContentId, params, dataSource} = this.state;
        let keywords = params.keywords;
        let page = params.page;
        let size = params.size;
        // 根据 tabKey 获取 navigationBarDate 中对应的对象
        let thisTab = navigationBarDate.find(item => item.key == tabKey);
        // 根据上面获取的对象,取到url
        let url = thisTab.url;
        this.request({
            url,
            body: {mediaId, treeContentId, keywords, page, size},
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if (res) {
                    total = res.count;
                    dataSource = res.data;
                }
                this.setState({
                    total,
                    dataSource,
                })
            },
            errorCallBack: (e) => {
            },
        })
    };

    // 获取投稿部门/媒体树
    getNodes = () => {
        this.request({
            url: getNodesUrl,
            callBack: (res) => {
                let treeData = [];
                if (res) {
                    treeData = res;
                }
                this.setState({treeData})
            },
            errorCallBack: (e) => {
                this.setState({treeData: []})
            }
        })
    };

    // 获取当前媒体站群版本
    getWebSiteVersion = () => {
        this.request({
            url: getWebSiteVersion,
            body: {mediaId: this.state.mediaId},
            callBack: (res) => {
                let webSiteVersion = "";
                if(res) {
                    webSiteVersion = res
                }
                this.setState({webSiteVersion})
            },
        })
    };

    // 保存重要性
    saveSignificance = () => {
        let {dataSource} = this.state;
        let webNewsIds = '';
        let wbweightstr = '';
        dataSource.forEach((item,index)=>{
            let column = item;
            if(!(this.state.contentId == item.contentId)) {
                column = item.deliveryNews.find(item => item.contentId == this.state.contentId)
            }
           if(index == 0) {
               webNewsIds += item.id;
               wbweightstr += column.wbweight;
           } else {
               webNewsIds += (','+ item.id);
               wbweightstr += (','+column.wbweight);
           }
        });
        if(!webNewsIds || !wbweightstr) {
            // message.warning("没有稿件需要更换重要性");
            return false
        }
        let body = {
            treeContentId: this.state.contentId,
            mediaId: this.state.mediaId,
            webNewsIds,wbweightstr
        };
        this.request({
            url: setImportance,
            method: 'post',
            body,
            callBack: (res) => {
                message.success('保存重要性成功');
                this.getSiteListContent()
            }
        })
    };

    // 文章排序
    saveSort = () => {
        this.storySortModal.showModal();

    };

    // 稿件状态操作，节点选择弹窗确认事件
    onStoryStateOk = (time) => {
        if (!time && doStoryState.needTime.indexOf(this.state.urlKey) > -1) {
            return this.setState({treeNodeWithdrawVisible: false,selectTimeVisible: true})
        }
        if (this.state.checkedWithdrawKeys && this.state.checkedWithdrawKeys.length) {
            let treeContentIds = this.state.checkedWithdrawKeys.join(',');
            this.state.treeNodeWithdrawVisible = false;
            this.state.checkedWithdrawKeys = [];
            this.doStoryState(treeContentIds, this.state.urlKey, time)
        }
    };

    onRangePickerChange({value, startKey, endKey}) {
        let startTime = value?value.valueOf():null;
        let endTime = startTime?value.valueOf():null;
        this.state[startKey] = startTime;
        this.state[endKey] = endTime;
        // 暂时只需要提示信息
        // let tenTimeAfter = new Date().getTime() + 10 * 60 * 1000;
        // if (this.state.toptime && this.state.toptime < tenTimeAfter) {
        //     // message.destroy();
        //     // message.error('如设置开始或结束时间，需要晚于当前时间至少10分钟！');
        //     return
        // }
        // if (this.state.gotoptime && this.state.gotoptime < tenTimeAfter) {
        //     // message.destroy();
        //     // message.error('如设置开始或结束时间，需要晚于当前时间至少10分钟！');
        //     return
        // }
        this.setState({})
    };

    contributeOk = () => {
        if (!(this.state.checkedKeys && this.state.checkedKeys.length)){
            message.destroy();
            message.warning('选择最少一个媒体或部门');
            return ;
        }
        let targetIds = this.state.checkedKeys.join(',');
        let webNewsId = this.state.webNewsId;
        let body = {targetIds, webNewsId};
        this.contribute(body);
        this.setState({treeNodeVisible: false})
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

    onNodeSearch = (textValue) => {
        if (textValue.length < 0) {
            this.state.expandedKeys = []
        }
        this.state.searchExpandedKeys = [];
        this.getSearchOpenKey(this.state.treeData, textValue);
        this.state.autoExpandParent = true;
        this.setState({searchText: textValue, expandedKeys: this.state.searchExpandedKeys})
    };

    //获取搜索搜索字段的展开树。
    getSearchOpenKey(data, searchText) {
        if (data && data.length > 0) {
            data.forEach((item) => {
                let index = searchText.length > 0 ? item.name.indexOf(searchText) : -1;
                if (index > -1) {
                    //if(item[childKey]&&item[childKey].length>0){
                    this.state.searchExpandedKeys.push(item["id"])
                    /* let keyIdArry=item[keyId].split('-')
                     keyIdArry.forEach((i)=>{
                        this.state.searchExpandedKeys.push(i)
                     })*/
                    // }
                }
                this.getSearchOpenKey(item["child"], searchText)
            })
        }
    }

    setTreeWithdrawData = (deliveryNews, config = {}) => {
        deliveryNews.forEach(item => {
            let index = this.state.treeWithdrawData.findIndex(item2 => item2.id == item.mediaId);
            if (item[config.key] == config.val) {
                if (index < 0) {
                    this.state.treeWithdrawData.push({
                        id: item.mediaId,
                        name: item.mediaName,
                        child: [
                            {
                                id: item.contentId,
                                name: item.contentName,
                            }
                        ]
                    })
                } else {
                    let index2 = this.state.treeWithdrawData[index].child.findIndex(item3 => item3.id == item.contentId);
                    if (index2 < 0) {
                        this.state.treeWithdrawData[index].child.push({
                            id: item.contentId,
                            name: item.contentName,
                        })
                    }
                }
            }
        });
    };

    setCollect = (item) => {
        let url = "";
        if (item.collect) { // 取消收藏
            url = cancelCollectionUrl;
        } else { // 收藏
            url = collectUrl;
        }
        this.request({
            url: url,
            body: {nodeId: item.id},
            method: "post",
            callBack: (res) => {
                this.getNodes()
            },
            errorCallBack: (e) => {
                message.error(e)
            }
        })
    };
    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.state.mediaId
            },
            callBack: (res) => {
                let disable = 0;
                if(res) {
                    disable = res.disable
                }
                this.setState({disable});
            }
        })
    };
    //稿件状态操作
    doStoryState = (treeContentIds, urlKey, time) => {
        let url = doStoryState[urlKey];
        if (!url) return false;
        let body = {treeContentIds, webNewsId: this.state.webNewsId};
        if (time) body = {...body, ...time};
        this.request({
            url,
            method: 'post',
            body,
            callBack: (res) => {
                if(res){
                    message.success('操作成功')
                }
                this.getSiteListContent()
            }
        })
    };

    //网站管理跳转
    WebsiteManagementButton = () => {
        this.request({
            url: '/cm-sites-pms/website/manage',
            body: {mediaId: this.state.mediaId},
            callBack: (res) => {
                if (res) {
                    this.openLoginPage(res.url, res.account, res.token, res.action)
                }
            }
        })
    };

    //访问网站跳转
    visitWebsite = () => {
        this.request({
            url: '/cm-sites-pms/website/access',
            body: {mediaId: this.state.mediaId},
            callBack: (res) => {
                if (res) {
                    window.open(res);
                }
            }
        })
    };

    //tab栏切换
    tabChange = (Key) => {
        this.state.params = {
            keywords:this.state.params.keywords,
            page: 1,
            size: 10,
        };
        this.state.tabKey = Key;
        this.getSiteListContent();
    };

    //搜索功能
    onSearch = (type, e) => {
        let {params} = this.state;
        switch (type) {
            case 'onChange':
                params['keywords'] = e.target.value;
                return this.setState({});
            case 'onSearch':
                params['keywords'] = e;
                params['page'] = 1;
                break;
            case 'page':
                params['page'] = e;
                break;
            case 'size':
                params['size'] = e;
                params['page'] = 1;
                break;
        }
        this.getSiteListContent();
    };

    // 投稿至树选择
    onCheck = (checkedKeys, info) => {
        console.log('checkedKeys       ', checkedKeys);
        this.setState({checkedKeys})
    };

    // 稿件状态修改（置顶头条推荐）栏目选择
    onWithdrawCheck = (checkedWithdrawKeys, info) => {
        let newChecked = checkedWithdrawKeys;
        console.log('newChecked       ', newChecked);
        console.log('this.state.record       ', this.state.record);
        if (checkedWithdrawKeys && checkedWithdrawKeys.length && (checkedWithdrawKeys.indexOf(this.state.record.contentId + '') > -1)) {
            newChecked = [this.state.record.contentId, ...this.state.record.deliveryNews.map(item => item.contentId)];
            message.destroy()
            message.warning('选择主节点后会默认选中其他节点')
        }
        this.setState({checkedWithdrawKeys: newChecked})
    };

    //新增文章
    addStory = () => {
        //获取网站流程的code
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
        let treeId = this.state.treeId;
        let mediaId = this.state.mediaId;
        let contentId = this.state.contentId;
        window.openEditById({
            configName: "webEditor",
            id: 0,params: {
                activitiConfName,treeId,mediaId,contentId,checkMainColumn:true
            }
        });
    };

    // 点击标题进入稿件编辑器
    editStory(id, record) {
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
        let treeId = this.state.treeId;
        let mediaId = this.state.mediaId;
        let contentId = this.state.contentId;
        let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn = noPublishConfig.indexOf(record.statusName)>-1?false:true
        mustNotShowPublishBtn = false; // 这个判断在编辑器里面已经执行了，外层不用再执行，稿件发布后这个参数就不对了（在不退出编辑器的情况下）。这里应该做的是当前稿件当前人永远不能发布的情况。
        const editorWindow = window.openEditById({
            configName: "webEditor",
            id: id,params:{
                activitiConfName,treeId,mediaId,contentId,storyType: "default",checkMainColumn:true,mustNotShowPublishBtn
            }
        });
        this.state.editorWindow = editorWindow;
    };

    editPhotos(record) {
        this.photos.showEditModal(record)
    }

    //网站管理
    openLoginPage(url, account, token, action) {
        var parames = new Array();
        parames.push({name: "account", value: account});
        parames.push({name: "token", value: token});
        parames.push({name: "action", value: action});
        this.openLoginPagePost(url, parames);
        return false;
    };

    //网站管理
    openLoginPagePost(URL, PARAMTERS) {
        //创建form表单
        var temp_form = document.createElement("form");
        temp_form.action = URL;
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        temp_form.target = "_blank";
        //添加参数
        for (var item in PARAMTERS) {
            var opt = document.createElement("textarea");
            opt.name = PARAMTERS[item].name;
            opt.value = PARAMTERS[item].value;
            temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
    };

    // 删除稿件
    delStory = (webNewsId) => {
        if(!webNewsId) return message.info('数据丢失');
        this.request({
            url: "/cm-sites-pms/website/news/deleteById",
            method: "post",
            body: {webNewsId},
            callBack: (res) => {
                message.success('删除成功！');
                this.getSiteListContent();
            }
        })
    };

    //预览
    previewCall=(id)=>{
        this.request({
            url:'/cm-sites-pms/website/news/getPreviewParam',
            body:{contentId:this.state.contentId,webNewsId:id},
            callBack:(res)=>{
                if (res){
                    this.openPreviewPage(res.url,
                        {
                            account:res.account,
                            token:res.token,
                            action:res.action,
                            newsid:res.newsid,
                            type:res.type,
                            owners:res.owners,
                        }
                    )
                }
            }
        })
    };
    //预览
    openPreviewPage(URL, PARAMTERS) {
        //创建form表单
        var temp_form = document.createElement("form");
        temp_form.action = URL;
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        temp_form.target = "_blank";
        //添加参数
        for (var key in PARAMTERS) {
            var opt = document.createElement("textarea");
            opt.name = key;
            opt.value = PARAMTERS[key];
            temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
    };
}


export default NetworkMediaJump;